var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('div',{style:(`height: 100%; width: 100%; backgroundImage: url(${this.getPlan}); backgroundSize: 100%;`),attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }